import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row, Select, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { DOCUMENT_TYPES } from "@config";
import { ApplicationsActions, selectCurrentApplicationId, selectIsUploadingDocs } from "@redux";

import "./UploadTab.less";

const { Option } = Select;

export const UploadTab = React.memo(() => {
  const dispatch = useDispatch();
  const isUploading = useSelector(selectIsUploadingDocs);
  const appId = useSelector(selectCurrentApplicationId);

  const [filesToUpload, setFilesToUpload] = useState([]);
  const [requestedDocInfo, setRequestedDocInfo] = useState({
    documentType: undefined,
    documentComment: ""
  });

  const addFileUploadToList = file => {
    setFilesToUpload([...filesToUpload, file]);
    return false;
  };

  const removeFileFromList = file => {
    const newFileList = [...filesToUpload];
    const index = newFileList.indexOf(file);
    newFileList.splice(index, 1);
    setFilesToUpload(newFileList);
  };

  const handleUploadDocuments = async () => {
    const formData = new FormData();
    filesToUpload.forEach(item => {
      formData.append("files", item);
      if (requestedDocInfo.documentComment) {
        formData.append("documentComment", requestedDocInfo.documentComment);
      }
    });

    await dispatch(
      ApplicationsActions.uploadDocumentsActions(appId, requestedDocInfo.documentType, formData)
    );
    setFilesToUpload([]);
    setRequestedDocInfo({
      documentType: undefined,
      documentComment: ""
    });
  };

  return (
    <>
      <Upload
        fileList={filesToUpload}
        beforeUpload={addFileUploadToList}
        onRemove={removeFileFromList}
        listType="picture-card"
        accept=".pdf,.jpg,.png,.bmp,.jpeg"
        multiple
        id="file"
        action=""
      >
        <div>
          <PlusOutlined />
          <div className="mt-2">{trb(i18.Buttons.Upload)}</div>
        </div>
      </Upload>

      <Row justify="space-between">
        <Col span={16}>
          <Select
            disabled={filesToUpload === 0}
            className="upload-docs-select"
            onChange={value => setRequestedDocInfo({ ...requestedDocInfo, documentType: value })}
            value={requestedDocInfo.documentType ?? trb(i18.Labels.SelectDocType)}
          >
            {Object.values(DOCUMENT_TYPES).map(doc => (
              <Option value={doc} key={doc}>
                {trb(i18.ApplicationsDocuments[doc])}
              </Option>
            ))}
          </Select>
          <Input
            onChange={e =>
              setRequestedDocInfo({ ...requestedDocInfo, documentComment: e.target.value })
            }
            placeholder={trb(i18.ApplicationsLabels.UploadDocComment)}
            className="w-100 mt-3"
            value={requestedDocInfo.documentComment}
          />

          <Button
            onClick={handleUploadDocuments}
            type="primary"
            disabled={filesToUpload.length === 0 || !requestedDocInfo.documentType}
            loading={isUploading}
            className="mt-3"
          >
            {trb(i18.Buttons.Upload)}
          </Button>
        </Col>
      </Row>
    </>
  );
});
